// Anglar
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
	ContentAnimateDirective,
	HeaderDirective,
	MenuDirective,
	OffcanvasDirective,
	ScrollTopDirective,
// 	SparklineChartDirective,
	StickyDirective,
	TabClickEventDirective,
	NumberDirective,
	ToggleDirective,
	TwoDigitDecimalNumberDirective,
} from '../../../src/app/services/index';

import { 
  SafePipe,
	FirstLetterPipe,
	GetObjectPipe,
	JoinPipe,
	CustomDatePipe,
	TextFormatPipe,
	TotalHoursPipe,
	FirstLetterOnlyPipe,
	TimeElapsedPipe,
	TruncatePipe,
	SplitStringPipe,
	TotalHoursWithoutSecsPipe,
  CustomCurrencyFormatPipe,
 } from '../../../src/app/services/index';

//
import { CookieService } from 'ngx-cookie-service';
// Crud Services
import { AppDateFormatterDirective } from '../../../src/app/services/index';
import { DiscountonlyDirective } from '../../../src/app/services/index';
import { CharactersDirective } from '../../../src/app/services/index';
@NgModule({
	imports: [CommonModule],
	declarations: [
		// directives
		ScrollTopDirective,
		HeaderDirective,
		OffcanvasDirective,
		ToggleDirective,
		MenuDirective,
		TabClickEventDirective,
		// SparklineChartDirective,
		ContentAnimateDirective,
		CharactersDirective,
		StickyDirective,
		NumberDirective,
		TwoDigitDecimalNumberDirective,
		AppDateFormatterDirective,
		DiscountonlyDirective,
		// pipes
		TimeElapsedPipe,
		JoinPipe,
		GetObjectPipe,
		SafePipe,
		FirstLetterPipe,
		CustomDatePipe,
		TextFormatPipe,
		FirstLetterOnlyPipe,
		TotalHoursPipe,
		TruncatePipe,
		SplitStringPipe,
		CustomCurrencyFormatPipe,
		TotalHoursWithoutSecsPipe,
		TwoDigitDecimalNumberDirective,
		AppDateFormatterDirective,
		DiscountonlyDirective
	],
	exports: [
		// directives
		ScrollTopDirective,
		HeaderDirective,
		OffcanvasDirective,
		ToggleDirective,
		MenuDirective,
		TabClickEventDirective,
		// SparklineChartDirective,
		ContentAnimateDirective,
		StickyDirective,
		NumberDirective,
		AppDateFormatterDirective,
		TwoDigitDecimalNumberDirective,
		DiscountonlyDirective,
		// pipes
		TimeElapsedPipe,
		JoinPipe,
		GetObjectPipe,
		SafePipe,
		FirstLetterPipe,
		CustomDatePipe,
		CustomCurrencyFormatPipe,
		TextFormatPipe,
		FirstLetterOnlyPipe,
		TotalHoursPipe,
		TruncatePipe,
		SplitStringPipe,
		TotalHoursWithoutSecsPipe,
		TwoDigitDecimalNumberDirective,
		DiscountonlyDirective
	],
	providers: [
		CookieService,
		CustomDatePipe,
		FirstLetterPipe,
		TotalHoursPipe,
		TotalHoursWithoutSecsPipe,
	]
})
export class CoreModule {
}
